export const CareersList = [
  {
    id: 1,
    titleDisplay: (
      <span className="text-[16px] sm:text-[18px] md:text-[20px] lg:text-[21px]">
        Machine Learning Project Engineer <br />
        <span className="text-[12px] sm:text-[14px] md:text-[15px] lg:text-[16px] text-gray-600">
          (Speech Technology)
        </span>
      </span>
    ),
        title:"Machine Learning Project Engineer",


    location: "IIT Madras Chennai, India",
    type: "Full-time",
    tags: ["Engineering", "Full-time"],
    lastDate: "10/07/2025",
    description:
      "We are looking to hire 2-3 talented and enthusiastic Machine Learning Engineers to join our core product team. In this role, you will be responsible for designing, building, and deploying the next generation of our speech and language models. You will work with massive datasets and cutting-edge algorithms to push the boundaries of what's possible in speech technology.",
    requirements: [
      "A Bachelor's or Master's degree in Computer Science, Electrical Engineering, AI, or a related technical field.",
      <span>
        A minimum of <strong>0-1 year of experience</strong> in Artificial
        Intelligence (AI) and Machine Learning (ML).
      </span>,

      <span>
        Strong programming skills in <strong>Python</strong>.
      </span>,
      <span>
        Experience with deep learning frameworks like <strong>PyTorch</strong>{" "}
        or <strong>TensorFlow</strong>.
      </span>,
      "Knowledge of fundamental ML algorithms and concepts (e.g., Deep Neural Networks, Transformers, RNNs, Attention Mechanisms).",
      "Familiarity with common data science libraries (e.g., NumPy, Pandas, Scikit-learn).",
      "A strong problem-solving mindset and the ability to work independently and as part of a team.",
    ],
  },
  {
    id: 2,
     titleDisplay: (
      <span className="text-[16px] sm:text-[18px] md:text-[20px] lg:text-[21px]">
        Machine Learning Senior Project Engineer <br />
        <span className="text-[12px] sm:text-[14px] md:text-[15px] lg:text-[16px] text-gray-600">
          (Speech Technology)
        </span>
      </span>
    ),
    title:"Machine Learning Senior Project Engineer",
    location: "IIT Madras Chennai, India",
    type: "Full-time",
    tags: ["Engineering", "Full-time"],
    lastDate: "10/07/2025",
    description:
      "We are looking to hire 2-3 talented and enthusiastic Machine Learning Engineers to join our core product team. In this role, you will be responsible for designing, building, and deploying the next generation of our speech and language models. You will work with massive datasets and cutting-edge algorithms to push the boundaries of what's possible in speech technology.",
    requirements: [
      "A Bachelor's or Master's degree in Computer Science, Electrical Engineering, AI, or a related technical field.",
      <span>
        A minimum of{" "}
        <strong>2+ years of hands-on professional experience</strong> in
        Artificial Intelligence (AI) and Machine Learning (ML).
      </span>,
      <span>
        Proven experience in{" "}
        <strong>building, training, and evaluating ML models</strong> from
        scratch.
      </span>,
      <span>
        Strong programming skills in <strong>Python</strong>.
      </span>,
      <span>
        Hands-on experience with deep learning frameworks like{" "}
        <strong>PyTorch</strong> or <strong>TensorFlow</strong>.
      </span>,
      "Solid understanding of fundamental ML algorithms and concepts (e.g., Deep Neural Networks, Transformers, RNNs, Attention Mechanisms).",
      "Familiarity with common data science libraries (e.g., NumPy, Pandas, Scikit-learn).",
      "A strong problem-solving mindset and the ability to work independently and as part of a team.",
    ],
  },
];

export const openings = [
  {
    id: 1,
    title: "Machine Learning Project Engineer (Speech Technology)",
    urgent: false,
    department: "Engineering",
    location: "IIT Madras Chennai, India",
    type: "Full-time",
  },
  {
    id: 2,
    title: "Machine Learning Senior Project Engineer (Speech Technology)",
    urgent: false,
    department: "Engineering",
    location: "IIT Madras Chennai, India",
    type: "Full-time",
  },
];
